const jsonSchema = [
  {
    name: 'shared',
    label: 'Shared',
    type: 'checkbox',
    isChecked: true,
    required: true
  },
  {
    name: 'dueDate',
    label: 'Due Date',
    type: 'date',
    maxWidth: '20%',
    showInList: true,
    required: true
  },
  {
    name: 'reviewer',
    label: 'Reviewer',
    type: 'multiselect',
    showInList: true,
    isMulti: false,
    required: true,
    maxWidth: '50%'
  },
  {
    name: 'employee',
    label: 'Employee',
    required: true,
    showInList: true,
    type: 'multiselect',
    isMulti: false,
    maxWidth: '50%'
  }
];
export default jsonSchema;
